<template>
  <Transition name="loader-fade">
    <div v-if="loaderStore.visible" class="app-loader-overlay">
      <!-- Background navy -->
      <div class="absolute inset-0 bg-navy"></div>

      <!-- Subtle teal glow -->
      <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-teal/10 rounded-full blur-3xl pointer-events-none"></div>

      <!-- Content -->
      <div class="relative z-10 flex flex-col items-center gap-6">
        <!-- Logo -->
        <div class="w-16 h-16 bg-offwhite rounded-2xl flex items-center justify-center shadow-2xl">
          <img
            src="/src/assets/enval.png"
            alt="Smart LabStock"
            class="w-11 h-11 object-contain"
            onerror="this.style.display='none';this.nextElementSibling.style.display='block'"
          />
          <svg style="display:none" viewBox="0 0 40 40" fill="none" class="w-8 h-8">
            <path d="M14 4h12M15 4v10L6 28a10 10 0 1028 0L25 14V4" stroke="#0F2A47" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            <circle cx="13" cy="30" r="2" fill="#0F2A47" opacity="0.5"/>
            <circle cx="22" cy="33" r="1.5" fill="#0F2A47" opacity="0.4"/>
          </svg>
        </div>

        <!-- App name -->
        <div class="text-center">
          <p class="text-offwhite font-bold text-xl tracking-wide">Smart LabStock</p>
          <p class="text-offwhite/40 text-xs mt-1">{{ loaderStore.message }}</p>
        </div>

        <!-- Progress bar -->
        <div class="w-48 h-1 bg-offwhite/10 rounded-full overflow-hidden">
          <div
            class="h-full bg-teal rounded-full transition-all duration-300 ease-out"
            :style="{ width: loaderStore.progress + '%' }"
          ></div>
        </div>

        <!-- Animated dots -->
        <div class="flex gap-1.5">
          <span class="dot" style="animation-delay:0s"></span>
          <span class="dot" style="animation-delay:0.2s"></span>
          <span class="dot" style="animation-delay:0.4s"></span>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { useLoaderStore } from '@/stores/loader.js'
const loaderStore = useLoaderStore()
</script>

<style scoped>
.app-loader-overlay {
  position: fixed;
  inset: 0;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dot {
  width: 6px;
  height: 6px;
  background: #2DD4BF;
  border-radius: 50%;
  animation: dotPulse 1.2s ease-in-out infinite;
  opacity: 0.3;
}

@keyframes dotPulse {
  0%, 100% { opacity: 0.3; transform: scale(0.8); }
  50%       { opacity: 1;   transform: scale(1.2); }
}

.loader-fade-enter-active { transition: opacity 0.2s ease; }
.loader-fade-leave-active { transition: opacity 0.4s ease 0.1s; }
.loader-fade-enter-from,
.loader-fade-leave-to    { opacity: 0; }
</style>
